import { motion } from "framer-motion";
import { MaskLines, Reveal, Eyebrow } from "@/components/Motion";
import { CTAPair } from "@/components/CTAButtons";
import { MENU, SITE } from "@/data/site";

const Category = ({ cat, index }) => (
  <section id={cat.id} className="scroll-mt-40 border-t border-cocoa/15 py-16 sm:py-24" data-testid={`menu-category-${cat.id}`}>
    <div className="grid gap-10 lg:grid-cols-12 lg:gap-16">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-40">
          <p className="font-mono text-sm text-hibiscus">0{index + 1} / 04</p>
          <h2 className="mt-3 font-display text-5xl leading-none sm:text-6xl"><em>{cat.es}</em></h2>
          <p className="mt-3 font-mono text-xs uppercase tracking-[0.25em] text-cocoa/70">{cat.en} · {cat.note}</p>
          <Reveal className="mt-8">
            <div className="overflow-hidden rounded-[28px] [clip-path:inset(0_round_28px)]">
              <img src={cat.img} alt={cat.en} className="aspect-[4/3] w-full object-cover transition-transform duration-[1.4s] hover:scale-105" />
            </div>
          </Reveal>
        </div>
      </div>
      <ul className="lg:col-span-7">
        {cat.items.map((item, i) => (
          <motion.li
            key={item}
            initial={{ opacity: 0.15, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
            className="group flex items-baseline gap-5 border-b border-dashed border-cocoa/20 py-6"
            data-testid={`menu-item-${cat.id}-${i}`}
          >
            <span className="font-mono text-xs text-cocoa/60">{String(i + 1).padStart(2, "0")}</span>
            <span className="font-display text-2xl transition-[color,transform] duration-300 group-hover:translate-x-2 group-hover:text-hibiscus sm:text-4xl">{item}</span>
          </motion.li>
        ))}
      </ul>
    </div>
  </section>
);

export default function MenuPage() {
  return (
    <>
      <section className="relative overflow-hidden bg-cocoa pb-16 pt-40 text-cream" data-testid="menu-hero">
        <div className="pointer-events-none absolute -right-32 top-0 h-[420px] w-[420px] rounded-full bg-mango/20 blur-[120px]" />
        <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
          <Eyebrow className="text-mango">Nuestro menú · Our menu</Eyebrow>
          <MaskLines testId="menu-title" className="mt-5 font-display text-6xl leading-[0.95] sm:text-8xl lg:text-[9rem]" lines={[<>El <em className="text-mango">Menú.</em></>]} />
          <p className="mt-6 max-w-xl text-lg text-cream/80">Home-style Dominican and Puerto Rican cooking. Every meat comes with your choice of side. Call {SITE.phone} for today's prices and to order ahead.</p>
          <nav className="mt-10 flex flex-wrap gap-2" data-testid="menu-category-nav">
            {MENU.map((c) => (
              <a key={c.id} href={`#${c.id}`} data-testid={`menu-nav-${c.id}`} className="rounded-full border border-cream/25 px-5 py-2.5 text-sm transition-colors hover:border-mango hover:bg-mango hover:text-cocoa">
                {c.en} <span className="ml-1 font-display italic text-cream/70">· {c.es}</span>
              </a>
            ))}
          </nav>
        </div>
      </section>
      <div className="bg-cream">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          {MENU.map((c, i) => <Category key={c.id} cat={c} index={i} />)}
        </div>
        <div className="border-t border-cocoa/15 bg-cream py-20">
          <Reveal className="mx-auto flex max-w-7xl flex-col justify-between gap-8 px-5 sm:px-8 md:flex-row md:items-center">
            <p className="max-w-xl font-display text-3xl sm:text-4xl">Know what you want? <em className="text-hibiscus">Call it in for takeout.</em></p>
            <CTAPair prefix="menu" dark />
          </Reveal>
        </div>
      </div>
    </>
  );
}
